

const MMPLDashboardReducer = (state = {}, action) => {
    switch (action.type) {
        case "GetMMPLDueListSuccess": {
            return Object.assign({}, state, {
                MmplDueList: action.data,
            });
            break;
        }
        case "GetMMPLDueListFailure":
            return Object.assign({}, state, {
                MmplDueList: action.data,
            });
            break;
        case "GetMMPLCompaniesListSuccess":
            return Object.assign({}, state, {
                MMPLCompaniesList: action.data,
            });
            break;
        case "GetMMPLCompaniesListFailure":
            return Object.assign({}, state, {
                MMPLCompaniesList: action.data,
            });
            break;
        default: {
            return state;
        }

    }
};
export default MMPLDashboardReducer;
